import script from "./EditMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./EditMenuItem.vue?vue&type=style&index=0&id=267f0aab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267f0aab"]])

export default __exports__